import { Button } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { AssetsService } from "app/services/AssetsService";
import {
    StyledHeader,
    StyledModalContent,
    StyledSubtitle,
    StyledTitle,
    StyledMainContainer,
    StyledImageContainer,
    StyledButtonsContainer,
    CUSTOM_MODAL_STYLES,
} from "./styles";

type SaveSearchSuccessModalProps = {
    isOpened: boolean;
    onSubmitClick(): void;
};

const SaveSearchSuccessModal = (props: SaveSearchSuccessModalProps) => {
    const { isOpened, onSubmitClick } = props;

    return (
        <ProModal
            isOpen={isOpened}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalContent data-automation="save-search-success-modal">
                <StyledHeader>
                    <I18n
                        element={StyledTitle}
                        data-automation="modal-title"
                        translatable={{ key: "si.components.save_search_success_modal.title" }}
                    />
                    <I18n
                        element={StyledSubtitle}
                        data-automation="modal-subtitle"
                        translatable={{ key: "si.components.save_search_success_modal.subtitle" }}
                    />
                </StyledHeader>
                <StyledMainContainer>
                    <StyledImageContainer>
                        <img
                            alt="save search success picture"
                            src={AssetsService.assetUrl("/images/sales-intelligence/save-search-success.svg")}
                        />
                    </StyledImageContainer>
                </StyledMainContainer>
                <StyledButtonsContainer>
                    <Button
                        onClick={onSubmitClick}
                        dataAutomation="save-search-success-modal-button-submit"
                    >
                        {translate("si.components.save_search_success_modal.button.submit")}
                    </Button>
                </StyledButtonsContainer>
            </StyledModalContent>
        </ProModal>
    );
}

export default SaveSearchSuccessModal;
